<template>
    <section class="delivery-informations">
        <h2 v-if="data.title" v-html="translate(data.title)"/>

        <div v-if="data.values" class="elements-container">

            <div v-for="(element,key) in data.values" class="element delivery-element" v-if="key!=='zz_summary_price'">
                <template v-if="element.variable !== undefined">
                    <span class="title" v-html="getVariable(element.title).variableTranslation"/>

                    <template v-if="!isEditable">
                        <span v-if="element.title" class="value"
                              v-html="getVariableDefaultValue(element.title)"/>
                    </template>

                    <offer_editable_property_value
                            v-else
                            :initialData="getVariable(element.title).variableValues"
                            :defaultKey="getVariable(element.title).variableDefaultKey"
                            :elementKey="element.title"/>

                </template>

                <template v-else>
                    <div class="element-left-side">
                      <span class="title"
                            v-html="((element.count_prefix)?element.count_prefix+' ':'')+translate(element.title)+((element.suffix)?' '+element.suffix:'')"
                            v-if="!key.includes('surcharge_')"></span>
                      <span class="title" v-else>
                        <div class="flex">
                            {{ translateOption(element.id, element.title) }}

                          <ul v-if="element.non_standard_surcharges == 1 && element.options && element.options.length">
                              <li v-if="element.options" v-for="(option, optKey) in element.options" :key="optKey">
                                {{option}}
                              </li>
                            </ul>
                        </div>
                      </span>

                      <div class="element-image-container">
                        <img v-if="element.is_image_visible && element.is_image_visible == 1"
                             :src="`data:image;base64, ${element.image}`"
                             alt="element_image"
                        >
                      </div>
                    </div>

                  <div class="price" v-bind:class="{ 'hide-in-pdf': element.hidePrice }" v-if="(($store.state.userRole === 'admin') || !element.hidePrice) && renderComponent">
                    <span class="PLN_value hide-in-pdf" v-if="$store.state.userRole === 'admin'" v-html="element.type == 'inPrice' ? '0.00 PLN' : (convertStringEURToNumber(element.value) * euro_rate).toFixed(2) + ' PLN'"/>
                    <span class="value" v-if="!currency"
                          v-html="parseInt(element.value) == 0 || element.type == 'inPrice' ? translate('in_price') : $priceController.convertWithThousandSeparator(element.value)"/>
                    <span class="value" v-else
                          v-html="parseInt(element.value) == 0 || element.type == 'inPrice' ? translate('in_price') : $priceController.convertWithThousandSeparator(convertStringEURToCurrency(element.value))"/>
                    <i class="icon " v-bind:class="{ 'icon-eye': !element.hidePrice, 'icon-eye-off': element.hidePrice }" v-if="($store.state.userRole === 'admin') && isEditable"  @click="hideShowElementPrice(key)"></i>
                    <i class="icon disabled" v-bind:class="{ 'icon-eye': !element.hidePrice, 'icon-eye-off': element.hidePrice }" v-if="($store.state.userRole === 'admin') && !isEditable && containDisabledPrice()"></i>
                  </div>

                </template>
            </div>

            <!-- NVS-95 -->
            <div v-for="(element,key) in data.discounts" class="element delivery-element hide-in-pdf">
              <template>
                <div class="element-left-side">
                  <span class="title"
                        v-html="((element.count_prefix)?element.count_prefix+' ':'')+translate(element.title)+((element.suffix)?' '+element.suffix:'')"
                        v-if="!key.includes('discount_')"></span>
                  <span class="title" v-else>
                    <div class="flex hide-in-pdf">
                        {{ translateDiscountOption(element.id, element.title) }}

                      <ul v-if="element.non_standard_discounts == 1 && element.options && element.options.length">
                          <li v-if="element.options" v-for="(option, optKey) in element.options" :key="optKey">
                            {{option}}
                          </li>
                        </ul>
                    </div>
                  </span>

                  <div class="element-image-container">
                    <img v-if="element.is_image_visible && element.is_image_visible == 1"
                          :src="`data:image;base64, ${element.image}`"
                          alt="element_image"
                    >
                  </div>
                </div>

                <div class="price hide-in-pdf" v-if="($store.state.userRole === 'admin') && renderComponent">
                  <span class="value" v-html="element.value + '%'"/>
                </div>
              </template>
            </div>
          <offer_admin_discount v-if="this.type === 'summary'" />
<!--          <div class="element delivery-element" v-if="this.type === 'summary' && ($store.state.userRole === 'admin') && isEditable">-->
<!--            <span class="title" v-html="translate('discount')"/>-->
<!--            <div class="edit-box">-->
<!--              <input type="text" class="edit-input" v-model="offerDiscountGivenByTheAdministrator">-->
<!--              <span class="percent">%</span>-->
<!--            </div>-->
<!--          </div>-->
            <div class="element delivery-element finalPrice" v-bind:class="{ 'hide-in-pdf': hideFinalPrice }" v-if="this.type === 'summary' && renderComponent">
                <span/>
                <span class="PLN_value hide-in-pdf" v-if="$store.state.userRole === 'admin'" v-html="data.values['zz_summary_price']?(convertStringEURToNumber(data.values['zz_summary_price'].value) * euro_rate).toFixed(2) + ' PLN':''"/>
                <span class="value summary-price right-align" v-if="!currency"
                      v-html="translate('summary_price')+': '+(data.values['zz_summary_price']?data.values['zz_summary_price'].value:'')"/>
                <span class="value summary-price right-align" v-else
                      v-html="translate('summary_price')+': '+(data.values['zz_summary_price']?convertStringEURToCurrency(data.values['zz_summary_price'].value):'')"/>
                <i class="icon " v-bind:class="{ 'icon-eye': !hideFinalPrice, 'icon-eye-off': hideFinalPrice }" v-if="($store.state.userRole === 'admin') && isEditable" @click="hideShowFinalPrice"></i>
                <i class="icon disabled" v-bind:class="{ 'icon-eye': !hideFinalPrice, 'icon-eye-off': hideFinalPrice }" v-if="($store.state.userRole === 'admin') && !isEditable && containDisabledPrice()"></i>
            </div>
        </div>
        <div class="navi-btns surcharges" v-if="this.type === 'summary'">
            <button type="button"
                    class="summary-btn"
                    v-if="($store.state.userRole === 'admin') && isEditable"
                    @click="openSurchargesModal">
                {{translate('surcharges_edit')}}
            </button>
            <button type="button"
                    class="summary-btn"
                    v-if="($store.state.userRole === 'admin') && isEditable"
                    @click="openDiscountsModal">
                {{translate('discounts_edit')}}
            </button>
        </div>
        <surchargesModal class="surchargesModal" @close="closeSurchargesModal" v-if="surchargesModalShow"/>
        <discountsModal class="surchargesModal" @close="closeDiscountsModal" v-if="discountsModalShow"/>
        <!-- NVS-148 -->
        <div class="comment" v-if="this.type === 'comment'" v-html="data.value"></div>
    </section>
</template>

<script>
    import Offer_editable_property_value from "../offers/offer_editable_property_value";
    import Offer_admin_discount from "../offers/offer_admin_discount";
    import surchargesModal from "./surchargesModal";
    import discountsModal from "./discountsModal";

    export default {
        name: "additionalInformationComponent",
        props: ['data', 'type', 'currency'],
        components: {Offer_editable_property_value, Offer_admin_discount, surchargesModal, discountsModal},
        data() {
            return {
                renderComponent: true,
                surchargesModalShow: false,
                discountsModalShow: false,
                hideFinalPrice: false,
                allPricesHidden: false
            }
        },
        watch:{
          offerDiscountGivenByTheAdministrator(newVal, oldVal){
              if(newVal != oldVal){
                this.loadAllPrices();
                this.sumAdditionalAccessoriesPrice();
                this.$emit('updatePrice');
                this.forceRerender();
              }
          },
          additionalDiscount(newVal, oldVal) {
            if(newVal != oldVal){
              this.loadAllPrices();
              this.sumAdditionalAccessoriesPrice();
              this.$emit('updateDiscount');
              this.$emit('updatePrice');
              this.forceRerender();
            }
          }
        },
        methods: {
            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

          sumAdditionalAccessoriesPrice() {
            let sum = 0;

            this.$store.state.productCard.custom.accesories.values.add_accessories.values.forEach((accesory) => {
              if (accesory.isActive) {
                sum += parseFloat(this.calculateDiscount(parseFloat(accesory.price)));
              }
            });

            this.$store.state.productCard.custom.accesories.sumAdditionalAccessoriesPrice = sum;
          },

          containDisabledPrice(){
            for(let elemKey in this.data.values){
              if(this.data.values.hasOwnProperty(elemKey) && this.data.values[elemKey].hidePrice)
                return true;
            }

            return false;
          },

          forceRerender() {
            // Remove my-component from the DOM
            this.renderComponent = false;

            // If you like promises better you can
            // also use nextTick this way
            this.$nextTick().then(() => {
              // Add the component back in
              this.renderComponent = true;
            });
          },

          // NVS-145
          hideShowFinalPrice() {
            this.hideFinalPrice = !this.hideFinalPrice;
          },

          hideShowElementPrice(key){
              if(!key || !this.data.values[key])
                return;

              if(this.data.values[key].is_accessories){
                //NVS-153
                let accessories = [
                  ...this.$store.state.productCard['custom'].accesories.values.included_accessories.values,
                  ...this.$store.state.productCard['custom'].accesories.values.add_accessories.values
                ]
                let accesoryId = accessories.findIndex(ac => ac.title == key);

                Vue.set(accessories[accesoryId], "hidePrice", !accessories[accesoryId].hidePrice);
              }

            Vue.set(this.data.values[key], "hidePrice", !this.data.values[key].hidePrice);
              this.forceRerender();
          },

            convertStringEURToCurrency(value) {
                return this.$priceController.convertWithThousandSeparator((parseFloat(value.split(' ').join('').replace("EUR", ""))*parseFloat(this.currency.euro_rate)).toFixed(2)) + ' ' + this.currency.currency;
            },

            // NVS-161
            convertStringEURToNumber(value) {
              return parseFloat(value.split(' ').join('').replace("EUR", ""));
            },

            openSurchargesModal() {
                this.surchargesModalShow = true;
            },

            openDiscountsModal() {
                this.discountsModalShow = true;
            },

            closeSurchargesModal() {
                this.surchargesModalShow = false;
            },

            closeDiscountsModal() {
                this.discountsModalShow = false;
            },

            calculateDiscount(price) {
                return this.$priceController.convertWithThousandSeparator(parseFloat(this.$priceController.calculateDiscountRaw(parseFloat(price), this.$store.state.discount)).toFixed(2));
            },

            translateOption(id, code) {
                let options = this.$store.state.offerSurcharges;
                if (options) {
                    let currentLang = this.getCurrentLocaleIndex(options);
                    let option = options.find(x => x.id.indexOf(id) !== -1);
                    if (option) {
                        let translation = option.language[currentLang].value;
                        if (translation) return translation;
                    }
                }
                return code;
            },

            // NVS-95
            translateDiscountOption(id, code) {
                let options = this.$store.state.offerDiscounts;
                if (options) {
                    let currentLang = this.getCurrentLocaleIndex(options);
                    let option = options.find(x => x.id.indexOf(id) !== -1);
                    if (option) {
                        let translation = option.language[currentLang].value;
                        if (translation) return translation;
                    }
                }
                return code;
            },

            getCurrentLocaleIndex(options) {
                if (options.length > 0) {
                    return options[0].language.findIndex(x => x.id_language === this.$store.state.activeLang.id);
                }
                return 0;
            },

            getVariable(code) {
                let arg = {
                    type: 'getVariable',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);
                if (arg.out === '' || null) {
                    return {variableTranslation: code, variableDefaultKey: 0, variableValues: []};
                }
                return arg.out;
            },
          loadAllPrices(){
            if (this.type === 'summary') {
              for (let sur in this.data.values) {
                if (this.data.values.hasOwnProperty(sur)) {
                  if (sur.includes('surcharge_')) {
                    this.data.values[sur].value = this.calculateDiscount(this.data.values[sur].price) + ' EUR';
                  } else if(this.data.values[sur].hasOwnProperty("price_before_discount")){
                    this.data.values[sur].value = this.calculateDiscount(this.data.values[sur].price_before_discount) + ' EUR';
                  }
                }
              }
            }
          },
        },
        computed: {
          isEditable() {
              if (this.$store.getters.getUserRole !== 'admin') return false;
              return this.$store.getters.isOfferEditable;
          },
          // NVS-161
          euro_rate() {
            return parseFloat(this.$store.state.currenciesList.find(x => x.currency === 'PLN').euro_rate);
          },
          offerDiscountGivenByTheAdministrator() {
            return this.$store.state.discount.offerDiscountGivenByTheAdministrator;
          },

          additionalDiscount() {
            return this.$store.state.discount.additionalDiscount;
          },

          getVariableDefaultValue() {
                return function (code) {
                    if (this.$store.state.productCard.custom.variables.hasOwnProperty(code)) {
                        let data = this.getVariable(code);
                        let value = data.variableValues.find(x => x.code === this.$store.state.productCard.custom.variables[code]);
                        if (value !== undefined) {
                            return value.value;
                        }
                    }
                    return this.$store.getters.getVariableDefaultValue(code);

                }
            },
        },
        mounted() {
          this.loadAllPrices();
        }
    }
</script>